<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleCancel">
      <span slot="title">请选择处方审核员</span>
      <div class="pass-reject-box" v-loading="loading">
        <div class="pass-reject-title">
          <img
            class="pass-reject-title-icon"
            src="@/assets/passReject/zyys.png"
            alt=""
          />
          <span>注册执业药师</span>
        </div>
        <div class="pass-reject-content">
          <div
            :class="[
              'pass-reject-content-item',
              { isdisabled: !pharmacist.isEnabled },
              { active: pharmacist.isChecked },
            ]"
            v-for="pharmacist in onlinePharmacists"
            :key="pharmacist.openId"
            @click="handlePharmacistChange(pharmacist)"
          >
            <img
              v-if="pharmacist.isChecked && pharmacist.isEnabled"
              class="pass-reject-content-item-icon"
              src="@/assets/passReject/check.png"
              alt=""
            />
            <div
              :class="[
                'pass-reject-content-item-title',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              <span>{{ pharmacist.realName }}</span>
              <span
                :class="[
                  'pass-reject-content-item-title-reason',
                  { lg: pharmacist.reason == '离岗' },
                ]"
                >{{ pharmacist.reason }}</span
              >
            </div>
            <div
              :class="[
                'pass-reject-content-item-content',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              到岗时间：{{ pharmacist.signedTime }}
            </div>
            <div
              :class="[
                'pass-reject-content-item-content',
                { isdisabled: !pharmacist.isEnabled },
              ]"
            >
              在岗时长：{{ pharmacist.signedLength }}
            </div>
          </div>
        </div>
        <block v-if="isHaveRemote">
          <div class="pass-reject-title">
            <img
              class="pass-reject-title-icon"
              src="@/assets/passReject/ycsfy.png"
              alt=""
            />
            <span>远程审方员</span>
            <span
              class="pass-reject-title-all"
              v-if="remotePharmacists.length > 0"
              @click="handleRemotePharmacistAllChange"
              >{{ isRemotePharmacistAllSelected ? "全不选" : "全选" }}</span
            >
          </div>
          <div class="pass-reject-chain">
            <span>{{ chainHeadName }}</span>
            <span class="pass-reject-chain-tag">{{ chainHeadProperty }}</span>
          </div>
          <div class="pass-reject-empty" v-if="isRemotePharmacistEmpty">
            未开通远程审方服务或远程审方员离线
          </div>
          <div class="pass-reject-content">
            <div
              :class="[
                'pass-reject-content-item',
                { isdisabled: !pharmacist.isEnabled },
                { active: pharmacist.isChecked },
              ]"
              v-for="pharmacist in remotePharmacists"
              :key="pharmacist.openId"
              @click="handleRemotePharmacistChange(pharmacist)"
            >
              <img
                v-if="pharmacist.isChecked && pharmacist.isEnabled"
                class="pass-reject-content-item-icon"
                src="@/assets/passReject/check.png"
                alt=""
              />
              <div
                :class="[
                  'pass-reject-content-item-title',
                  { isdisabled: !pharmacist.isEnabled },
                ]"
              >
                <span>{{ pharmacist.realName }}</span>
                <span
                  :class="[
                    'pass-reject-content-item-title-reason',
                    { lg: pharmacist.reason == '离岗' },
                  ]"
                  >{{ pharmacist.reason }}</span
                >
              </div>
              <div
                :class="[
                  'pass-reject-content-item-content',
                  { isdisabled: !pharmacist.isEnabled },
                ]"
              >
                到岗时间：{{ pharmacist.signedTime }}
              </div>
              <div
                :class="[
                  'pass-reject-content-item-content',
                  { isdisabled: !pharmacist.isEnabled },
                ]"
              >
                在岗时长：{{ pharmacist.signedLength }}
              </div>
            </div>
          </div>
        </block>
        <div class="pass-reject-button">
          <el-button
            plain
            @click="handleCancel"
            size="mini"
            style="margin-right: 50px"
            >取消</el-button
          >
          <el-button
            type="primary"
            :disabled="
              !selectedPharmacist && selectedRemotePharmacists.length === 0
            "
            size="mini"
            @click="handleSubmit"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PassReject",
  components: {},
  props: {},
  data() {
    return {
      dialogCodeVisible: false,
      loading: false,
      onlinePharmacists: [],
      remotePharmacists: [],
      selectedPharmacist: "",
      selectedRemotePharmacists: [],
      isRemotePharmacistAllSelected: false,
      form: {},
      chainHeadName: "",
      chainHeadProperty: "",
      isRemotePharmacistEmpty: false,
      isHaveRemote: false,
    };
  },
  methods: {
    handleRemotePharmacistAllChange() {
      this.selectedPharmacist = "";
      this.onlinePharmacists.forEach((item) => {
        item.isChecked = false;
      });
      const allEnabledItems = this.remotePharmacists.filter(
        (item) => item.isEnabled
      );
      const allChecked =
        allEnabledItems.length > 0 &&
        allEnabledItems.every((item) => item.isChecked);

      this.selectedRemotePharmacists = [];
      this.remotePharmacists.forEach((item) => {
        if (item.isEnabled) {
          item.isChecked = !allChecked;
          if (item.isChecked) {
            this.selectedRemotePharmacists.push(item.openId);
          }
        }
      });

      this.isRemotePharmacistAllSelected = !allChecked;
      this.$forceUpdate();
    },
    handleCancel() {
      this.selectedPharmacist = "";
      this.selectedRemotePharmacists = [];
      this.onlinePharmacists = [];
      this.remotePharmacists = [];
      this.isRemotePharmacistAllSelected = false;
      this.dialogCodeVisible = false;
    },
    async handleSubmit() {
      let pharmacists = [];
      let auditType = "";
      if (this.selectedPharmacist) {
        auditType = 0;
        let pharmacist = this.onlinePharmacists.find(
          (item) => item.openId === this.selectedPharmacist
        );
        if (pharmacist) {
          pharmacists.push(pharmacist);
        }
      }
      if (this.selectedRemotePharmacists.length > 0) {
        auditType = 1;
        let pharmacist = this.remotePharmacists.filter((item) =>
          this.selectedRemotePharmacists.includes(item.openId)
        );
        if (pharmacist.length > 0) {
          pharmacists.push(...pharmacist);
        }
      }
      this.loading = true;
      await this.$api.prescription.SubmitPrescription({
        prescriptionId: this.form.id,
        auditType,
        pharmacists,
      });
      this.loading = false;
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    handlePharmacistChange(val) {
      if (!val.isEnabled) return;
      this.selectedRemotePharmacists = [];
      this.remotePharmacists.forEach((item) => {
        item.isChecked = false;
      });
      this.isRemotePharmacistAllSelected = false;
      this.onlinePharmacists.forEach((item) => {
        if (item.openId === val.openId) {
          item.isChecked = true;
          this.selectedPharmacist = item.openId;
        } else {
          item.isChecked = false;
        }
      });
      this.$forceUpdate();
    },
    handleRemotePharmacistChange(val) {
      if (!val.isEnabled) return;
      const wasRemoteSelected = this.selectedRemotePharmacists.length > 0;
      if (!wasRemoteSelected) {
        this.selectedPharmacist = "";
        this.onlinePharmacists.forEach((item) => {
          item.isChecked = false;
        });
      }
      this.remotePharmacists.forEach((item) => {
        if (item.openId === val.openId) {
          item.isChecked = !item.isChecked;
          if (item.isChecked) {
            this.selectedRemotePharmacists.push(item.openId);
          } else {
            this.selectedRemotePharmacists =
              this.selectedRemotePharmacists.filter((v) => v !== item.openId);
          }
        }
      });
      const allEnabledItems = this.remotePharmacists.filter(
        (item) => item.isEnabled
      );
      this.isRemotePharmacistAllSelected =
        allEnabledItems.length > 0 &&
        allEnabledItems.every((item) => item.isChecked);
      this.$forceUpdate();
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.form = row;
      this.loading = true;
      const { data } =
        await this.$api.prescription.GetPrescriptionPharmacists();
      this.isHaveRemote = data.isHaveRemote || false;
      this.chainHeadName = data.chainHeadName || "";
      this.chainHeadProperty = data.chainHeadProperty || "";
      this.onlinePharmacists = data.onlinePharmacists || [];
      this.isRemotePharmacistEmpty =
        data.onlinePharmacists.length === 0 ? true : false;
      this.onlinePharmacists.forEach((item) => {
        item.isChecked = false;
      });
      this.remotePharmacists = data.remotePharmacists || [];
      this.remotePharmacists.forEach((item) => {
        item.isChecked = false;
      });
      this.isRemotePharmacistAllSelected = false;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./passReject.scss";
</style>
